








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Sidebar extends Vue {
  @Prop() caption!: string;

  @Prop({ default: 0 }) counter!: number;
}
